import { ALERT } from '../../model/msg/equip';
import { isDefined, not, notSingleEle, truthy, falsy, each, allOf, parseInt10, getFirstObjectHasProperty, overlappedConditionSortByProperty, getStatMaxByLevel} from '../../../../utils/util';
import { getMyCharacters, getSavedUserStats } from '../../utils/service';
import { handleApiError } from '../../../../utils/service';
import { getStatStorageItemTpl } from '../../model/tpl/stat';
import { API_DOMAIN_DEFAULT } from '../../../../model/model';
import MyCharacterStats from './MyCharacterStats';
import EquipModel from '../EquipModel';
import SingletonLoading from '../../utils/SingletonLoading'
import moment from 'moment';

class SelectStatLayer {
  constructor(options) {
    const _ = this;

    if (not(isDefined)(options)) throw new Error('SelectStatLayer constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      searchApiDomain: API_DOMAIN_DEFAULT,
      global: window
    }, options);

    _.model = EquipModel.getInstance();

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.myStatsWrap = null;
    _.savedStatsWrap = null;

    _.myCharacterStats = null;

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('SelectStatLayer wrap must be single element.');

    _.myStatsWrap = $('.simulator-my', _.wrap);
    _.savedStatsWrap = $('.simulator-storage', _.wrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    this.setBtns();
  }

  setBtns() {
    const _ = this;

    $('.btn-close', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      _.activateStatBtn(null);
      _.emptyMyStats();
      _.emptySavedStats();

      $(_).trigger({type: SelectStatLayer.EVT_CLOSE});
    });

    // my character stat
    $('.btn-my', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      if (truthy(_.loading.isLoading)) return;

      if (falsy(_.model.isLogin)) {
        handleApiError({status: 401});
        return;
      }

      _.activateStatBtn(this);

      // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=91226365#WebDev-리니지RWDAPI-My-GET/api/my/characters
      getMyCharacters({
        apiDomain: _.option.apiDomain,
        searchApiDomain: _.option.searchApiDomain,
        beforeSend: () => {
          _.emptyMyStats();

          _.loading.start();
        }

      }).then((data, textStatus, jqXHR) => {
        console.log('getMyCharacters - data :', data);

        _.loading.end();

        if (truthy(Array.isArray(data))) {
          // sort by descending level, ascending level, ascending createDate order
          let sortedResult = overlappedConditionSortByProperty(data, [{
            property: 'level',
            func: function(a, b) { return b.level - a.level; }
          }, {
            property: 'serverId',
            func: function(a, b) { return a.serverId - b.serverId; }
          }, {
            property: 'createDate',
            func: function(a, b) { return new Date(a.createDate).getTime() - new Date(b.createDate).getTime() }
          }]);

          data = sortedResult;

          // set representative character to top
          const userData = _.global.userData;

          if (allOf(isDefined(userData), isDefined(userData.gameAccount))) {
            const characterServerId = parseInt10(_.global.userData.gameAccount.serverId),
              characterName = userData.gameAccount.name;

            let obj;
            for (let i = 0, max = data.length; i < max; i++) {
              obj = data[i];

              if (allOf(parseInt10(obj.serverId) === characterServerId, obj.name === characterName)) {
                data = data.splice(i, 1).concat(data);
                break;
              }
            }
          }

          _.showMyStatsWrap(true);
          _.showSavedStatsWrap(false);
          _.emptySavedStats();

          if (data.length > 0) {
            _.setMyCharacterStats(data);

          } else {
            _.global.alert(ALERT.CREATE_GAME_CHARACTER); // '게임에 접속해 캐릭터를 먼저 생성해주세요.',
          }

        } else {
          _.global.alert(ALERT.FAIL_LOAD_MY_CHARACTERS); // '현재 내 캐릭터 스탯 정보를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',
        }

      }).catch((err) => {
        _.loading.end();

        if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_MY_CHARACTERS); // '현재 내 캐릭터 스탯 정보를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',
      });
    });

    // saved stat setting
    $('.btn-storage', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      if (truthy(_.loading.isLoading)) return;

      if (falsy(_.model.isLogin)) {
        handleApiError({status: 401});
        return;
      }

      _.activateStatBtn(this);

      // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/stat/user
      getSavedUserStats({
        apiDomain: _.option.apiDomain,
        searchApiDomain: _.option.searchApiDomain,
        beforeSend: () => {
          _.emptySavedStats();

          _.loading.start();
        }

      }).then((data, textStatus, jqXHR) => {
        console.log('SelectStatLayer.js then, getSavedUserStats - data :', data);

        _.loading.end();

        if (truthy(Array.isArray(data))) {
          // sort by descending date order
          data.sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());

          _.showSavedStatsWrap(true);
          _.showMyStatsWrap(false);
          _.emptyMyStats();

          if (data.length > 0) {
            // const statMax = _.model.STAT_MAX; // 2019.11
            //console.log('SelectStatLayer.js if data.length>0 getSavedUserStats - data :', data);

            let mainStat = null, itemsTpl = '';
            each(data, function (item) {

              // const statMax = (item.level >= _.model.LEVEL_CHANGE_STAT_MAX ) ? _.model.CHANGED_STAT_MAX : _.model.STAT_MAX;  // 2019.11
              // 2021.12
              // 2022.01 .level-> .targetLevel
              const statMax = getStatMaxByLevel(parseInt(item.targetLevel), _.model.STAT_MAX_BY_LEVEL);
              // console.log('=> SelectStatLayer.js, statMax : ', statMax);

              item.idx = item.idx;
              item.classId = item.classId;
              item.date = _.getDateStr(item.updateDate);
              item.hp = item.statMetaInfo.hp;
              item.mp = item.statMetaInfo.mp;

              mainStat = item.statMetaInfo.mainStat;

              for (let stat in mainStat) if (mainStat[stat] > statMax) mainStat[stat] = statMax;

              item.percentageSTR = `${(mainStat.STR / statMax) * 100}%`;
              item.percentageINT = `${(mainStat.INT / statMax) * 100}%`;
              item.percentageDEX = `${(mainStat.DEX / statMax) * 100}%`;
              item.percentageWIS = `${(mainStat.WIS / statMax) * 100}%`;
              item.percentageCON = `${(mainStat.CON / statMax) * 100}%`;
              item.percentageCHA = `${(mainStat.CHA / statMax) * 100}%`;

              const itemTplFunc = doT.template(getStatStorageItemTpl()),
                itemTpl = itemTplFunc(item);

              itemsTpl += itemTpl;
            });

            $('.storage-bundle', _.wrap).prepend(itemsTpl);

            _.setSavedStatItemsEvent(true);

          } else {
            _.global.alert(ALERT.NO_SAVED_STATS); // `저장한 스탯 세팅이 없습니다. 세팅한 스탯 저장 후 다시 진행해주세요.`,
          }

        } else {
          _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
        }

      }).catch((err) => {
        _.loading.end();

        if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    });
  }

  activateStatBtn(btn) {
    const _ = this;

    const myBtn = $('.btn-my', _.wrap),
      storageBtn = $('.btn-storage', _.wrap);

    (btn === myBtn.get(0)) ? myBtn.addClass('primary') : myBtn.removeClass('primary');
    (btn === storageBtn.get(0)) ? storageBtn.addClass('primary') : storageBtn.removeClass('primary');
  }

  // my character stats
  setMyCharacterStats(myCharacters) {
    const _ = this;

    _.emptyMyStats();

    _.myCharacterStats = new MyCharacterStats({
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
      wrap: _.myStatsWrap,
      data: myCharacters
    }).init();

    $(_.myCharacterStats).on(MyCharacterStats.SET_MY_CHARACTER_STAT, function (evt) {
      // evt.obj: {serverId, serverName, classId, classImageUrl, characterName, level, hp, mp, noEquipStats, stats, expandSlots, equipItems, changedStats: null, isEditable: true}
      console.log('SET_MY_CHARACTER_STAT evt.obj :', evt.obj);

      _.activateStatBtn(null);
      _.emptyMyStats();
      _.emptySavedStats();

      $(_).trigger({
        type: SelectStatLayer.EVT_SELECT_MY_STAT,
        obj: evt.obj
      });
    });
  }

  setSavedStatItemsEvent(flag) {
    const _ = this,
      stats = $('.storage-bundle .storage__stat', _.wrap);

    stats.each(function (index, stat) {
      if (truthy(flag)) {

        $(stat).on('click', function (evt) {
          evt.preventDefault();

          const $this = $(this);

          _.activateStatBtn(null);
          _.emptyMyStats();
          _.emptySavedStats();

          $(_).trigger({
            type: SelectStatLayer.EVT_SELECT_SAVED_STAT,
            obj: {
              idx: $this.attr('data-idx'),
              classId: $this.attr('data-class-id'),
              classImageUrl: $('.char > img', $this).attr('src'),
              level: parseInt10($('.level', $this).text()),
              hp: $this.attr('data-hp'),
              mp: $this.attr('data-mp'),
              mainStat: {
                STR: $('.stat-STR var', $this).text(),
                INT: $('.stat-INT var', $this).text(),
                DEX: $('.stat-DEX var', $this).text(),
                WIS: $('.stat-WIS var', $this).text(),
                CON: $('.stat-CON var', $this).text(),
                CHA: $('.stat-CHA var', $this).text()
              }
            }
          });
        });

      } else {
        $(stat).off('click');
      }
    })
  }

  emptyMyStats() {
    const _ = this;

    if (_.myCharacterStats) {
      $(_.myCharacterStats).off(MyCharacterStats.SET_MY_CHARACTER_STAT);

      _.myCharacterStats.destroy();
    }
    _.myCharacterStats = null;

    _.myStatsWrap.empty();
  }

  emptySavedStats() {
    const _ = this;

    _.setSavedStatItemsEvent(false);

    const storageListWrap = $('.storage-bundle', _.wrap);
    $('.storage__stat', storageListWrap).remove();
  }

  showMyStatsWrap(flag) {
    (truthy(flag)) ? this.myStatsWrap.show() : this.myStatsWrap.hide();
  }

  showSavedStatsWrap(flag) {
    (truthy(flag)) ? this.savedStatsWrap.show() : this.savedStatsWrap.hide();
  }

  getDateStr(dateStr, format = 'YYYY.MM.DD') {
    return moment(dateStr).format(format);
  }

  /*
   * public methods
   */
  show(flag) {
    (truthy(flag)) ? this.wrap.show() : this.wrap.hide();
  }
}

SelectStatLayer.EVT_CLOSE = 'EVT_CLOSE';
SelectStatLayer.EVT_SELECT_MY_STAT = 'EVT_SELECT_MY_STAT';
SelectStatLayer.EVT_SELECT_SAVED_STAT = 'EVT_SELECT_SAVED_STAT';

export default SelectStatLayer;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/selectStatLayer/SelectStatLayer.js